<template>
  <div class="postavitev-info">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          Če vklopite direktno bremenitev, je prejemanje računov možno
          le v elektronski obliki na vaš e-naslov ali v portal Moj T-2.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoKomponentaPrejemanjeRacunovDirektnaBremenitev'
}
</script>

<style scoped>
.info-okvir {
  width: 560px;
  height: 85px;
  display: flex;
}

@media only screen and (max-width: 1100px) {
  .info-okvir {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Eposlovanje/InfoKomponentaPrejemanjeRacunovDirektnaBremenitev.vue